import { Typography, TypographyProps } from '@mui/material';
import React from 'react';
import { colors } from '../../styles/theme/colors';

type ProfileFullNameProps = TypographyProps;

export function ProfileFullName({ children, sx, ...props }: ProfileFullNameProps) {
    return (
        <Typography
            variant="h1"
            sx={{
                color: colors.pink2,
                fontSize: '32px',
                fontWeight: 700,
                lineHeight: '44px',
                letterSpacing: 0,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Typography>
    );
}
